import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { AVAILABILITY_CLS, AVAILABILITY_LABELS } from "./constants";

export function OverviewTab({ arch, catalog, isConnected }) {
  return (
    <>
      <Card className="border-slate-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm">Capabilities {isConnected ? "reali (da JOBTIMEHR)" : "(da verificare: nessuna connessione attiva)"}</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 md:grid-cols-4 gap-2" data-testid="jt-capabilities">
          {(arch?.capabilities || []).map((c) => {
            const key = c.capability || c.domain;
            const avail = c.availability;
            return (
              <div key={key} className="flex items-center justify-between rounded-md border border-slate-200 p-2.5" data-testid={`capability-${key}`}>
                <span className="text-xs font-medium text-slate-700">{c.label || key}</span>
                <Badge variant="outline" className={`${AVAILABILITY_CLS[avail] || "bg-slate-100 text-slate-600"} text-[10px]`}>
                  {AVAILABILITY_LABELS[avail] || avail}
                </Badge>
              </div>
            );
          })}
        </CardContent>
      </Card>
      <Card className="border-slate-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm">Catalogo dati Social collegabili</CardTitle>
          <p className="text-xs text-slate-500">{arch?.disclaimer}</p>
        </CardHeader>
        <CardContent className="p-0 overflow-x-auto">
          <Table data-testid="jt-catalog">
            <TableHeader>
              <TableRow>
                <TableHead>KPI canonico</TableHead><TableHead>Datapoint VSME</TableHead>
                <TableHead>Capability</TableHead><TableHead>Stato</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {catalog.map((m) => (
                <TableRow key={m.metric_code} data-testid={`catalog-${m.metric_code}`}>
                  <TableCell>
                    <p className="text-sm font-medium text-slate-900">{m.label}</p>
                    <p className="text-[11px] text-slate-400">{m.metric_code} · fonte potenziale: {m.potential_source}</p>
                  </TableCell>
                  <TableCell className="text-xs text-slate-600">{m.datapoint_code || "(input di calcolo)"}</TableCell>
                  <TableCell><Badge variant="outline" className="text-[10px] bg-slate-50">{m.capability}: {AVAILABILITY_LABELS[m.capability_availability] || m.capability_availability}</Badge></TableCell>
                  <TableCell>
                    <Badge variant="outline" className={m.catalog_status === "READY_FOR_MAPPING" ? "bg-green-100 text-green-800 border-green-300 text-[10px]" : "bg-amber-100 text-amber-800 border-amber-300 text-[10px]"}>
                      {m.catalog_status === "READY_FOR_MAPPING" ? "READY FOR MAPPING" : "SOURCE AVAILABILITY TO VERIFY"}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  );
}
